<template>
	<div class="partial auth-register">
		<Card>
			<RegisterForm class="auth-register__form" />
			<div class="auth-register__message">
				Already have an account? <Button class="ml-1" look="flat" :to="{name: 'login'}" v-if="routeLink">Login here</Button><Button class="ml-1" look="flat" v-else @click="setLink('login')">Login here</Button>
			</div>
		</Card>
	</div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { useUserStore } from '@/lib/store/user'

import Button from '@/components/Button.vue'
import Card from '@/components/Card.vue'
import RegisterForm from '@/components/RegisterForm.vue'

export default {
	name: 'PartialAuthRegister',
	components: {
		Button,
		Card,
		RegisterForm,
	},
	setup() {
		useHead({
			title: `Registration`
		})

		return {
			userStore: useUserStore()
		}
	},
	props: {
		routeLink: true,
	},
	methods: {
		setLink() {
			this.userStore.authStep = 'login'
		}
	},
}
</script>

<style scoped lang="scss">
.auth-register {
	max-width: 440px;

	&__message {
		background-color: var(--color--background-light);
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		font-size: 0.95rem;
		margin-top: 1rem;
		padding: 1rem;
		text-align: center;
	}
}
</style>
